class ChangeGraphicColor {
    static CHANGE_GRAPHIC_COLOR_NAME = 'COMPONENT_BUY_DIALOG_';
    static loadGraphicSvg_NAME = 'LOAD_GRAPHIC_SVG_';
    static saveGraphicSvg_NAME = 'SAVE_GRAPHIC_SVG_';

    static loadGraphicSvg = {
        start:
            ChangeGraphicColor.CHANGE_GRAPHIC_COLOR_NAME +
            ChangeGraphicColor.loadGraphicSvg_NAME +
            'START',
        success:
            ChangeGraphicColor.CHANGE_GRAPHIC_COLOR_NAME +
            ChangeGraphicColor.loadGraphicSvg_NAME +
            'SUCCESS',
        fail:
            ChangeGraphicColor.CHANGE_GRAPHIC_COLOR_NAME +
            ChangeGraphicColor.loadGraphicSvg_NAME +
            'FAIL',
        reset:
            ChangeGraphicColor.CHANGE_GRAPHIC_COLOR_NAME +
            ChangeGraphicColor.loadGraphicSvg_NAME +
            'RESET',
    };

    static saveGraphicSvg = {
        start:
            ChangeGraphicColor.CHANGE_GRAPHIC_COLOR_NAME +
            ChangeGraphicColor.saveGraphicSvg_NAME +
            'START',
        success:
            ChangeGraphicColor.CHANGE_GRAPHIC_COLOR_NAME +
            ChangeGraphicColor.saveGraphicSvg_NAME +
            'SUCCESS',
        fail:
            ChangeGraphicColor.CHANGE_GRAPHIC_COLOR_NAME +
            ChangeGraphicColor.saveGraphicSvg_NAME +
            'FAIL',
        reset:
            ChangeGraphicColor.CHANGE_GRAPHIC_COLOR_NAME +
            ChangeGraphicColor.saveGraphicSvg_NAME +
            'RESET',
    };
}

export default ChangeGraphicColor;
